import { FC } from 'react';
import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { Heading, PrimaryButton, SecondaryButton, Text } from '@frontend/design-system';

const errorPageSectionStyle1 = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${theme.spacing(4)};
  text-align: center;
  max-width: 700px;
  h1,
  p {
    margin-bottom: ${theme.spacing(2)};
  }
`;

const errorPagePrimaryButtonStyle2 = css`
  width: auto;
  margin-right: ${theme.spacing(2)};
`;

const errorPageSecondaryButtonStyle3 = css`
  width: auto;
`;

type Props = {
  title: string | React.ReactElement;
  subTitle: string | React.ReactElement;
  primaryButtonText: string;
  secondaryButtonText?: string;
  primaryButtonOnClick: () => void;
  secondaryButtonOnClick?: () => void;
};

export const ErrorPage: FC<React.PropsWithChildren<Props>> = ({
  children,
  title,
  subTitle,
  primaryButtonText,
  secondaryButtonText,
  primaryButtonOnClick,
  secondaryButtonOnClick,
}) => (
  <section className={errorPageSectionStyle1}>
    {children}
    <Heading>{title}</Heading>
    <Text>{subTitle}</Text>
    <div>
      {!!primaryButtonText && (
        <PrimaryButton onClick={primaryButtonOnClick} size='large' className={errorPagePrimaryButtonStyle2}>
          {primaryButtonText}
        </PrimaryButton>
      )}
      {!!secondaryButtonText && (
        <SecondaryButton onClick={secondaryButtonOnClick} size='large' className={errorPageSecondaryButtonStyle3}>
          {secondaryButtonText}
        </SecondaryButton>
      )}
    </div>
  </section>
);
